import { api } from '../../../api/axios'
import type { RankingEtapaResponse, RankingGeralResponse } from '../types'

export const rankingsService = {
  getEtapa: (params: { idcampeonato: number; idmodalidade: number; idetapa: number }) =>
    api.get<RankingEtapaResponse>('/rankings/etapa', { params }).then(r => r.data),

  getGeral: (params: { idcampeonato: number; idmodalidade: number }) =>
    api.get<RankingGeralResponse>('/rankings/geral', { params }).then(r => r.data),

  recalcular: (params: { idcampeonato: number; idmodalidade?: number }) =>
    api.post('/rankings/recalcular', null, { params }).then(r => r.data),
}
